import { Drawer } from "components";
import { ConnectLevelAccount } from "./connect-level-account";
import { useGetLevelAuthConfig } from "controller";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface LevelDrawerProps {
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const LevelConnectionDrawer = ({
  open,
  onOpen,
  onClose,
}: LevelDrawerProps) => {
  const { data: levelAuthConfig } = useGetLevelAuthConfig();
  const [apiKey, setApiKey] = useState(levelAuthConfig?.data?.api_key || "");
  const navigate = useNavigate();
  const isPrimaryButtonDisabled =
    !levelAuthConfig?.data?.api_key ||
    levelAuthConfig?.data?.api_key !== apiKey;
  useEffect(() => {
    setApiKey(levelAuthConfig?.data?.api_key || "");
  }, [levelAuthConfig]);
  return (
    <Drawer
      title="Connect Level RMM"
      onClose={onClose}
      onOpen={onOpen}
      open={open}
      drawerStyle={{
        width: "496px",
      }}
      primaryButtonText={"Proceed"}
      secondaryButtonText="Cancel"
      isPrimaryButtonDisabled={isPrimaryButtonDisabled}
      onSecondaryButtonClick={onClose}
      onPrimaryButtonClick={() => {
        !isPrimaryButtonDisabled && navigate("level");
      }}
    >
      <ConnectLevelAccount apiKey={apiKey} setApiKey={setApiKey} />
    </Drawer>
  );
};
